import { useRouter } from 'next/router'
import { useCallback } from 'react'
import { useShellGate } from '../../iframe'

interface UseRedirectToLoginHook {
  redirectToLogin: ({
    redirect,
    email
  }: {
    redirect?: string
    email?: string
  }) => void
}

export const useRedirectToLogin = (): UseRedirectToLoginHook => {
  const router = useRouter()
  const { isShellDisabled, sendMessage } = useShellGate()

  const redirectToLogin = useCallback(
    async ({ redirect, email }: any) => {
      if (isShellDisabled) {
        sendMessage({
          type: 'SIGN_OUT',
          source: 'shell',
          payload: {
            email,
            redirect
          }
        })

        return
      }

      router.push({
        pathname: '/logout',
        query: {
          email,
          redirect
        }
      })
    },
    [router, isShellDisabled, sendMessage]
  )

  return {
    redirectToLogin
  }
}
